import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueI18n from 'vue-i18n'
import store from './store'

import Local from '@/plugins/Local'
import Device from '@/plugins/Device'
import Offset from '@/plugins/Offset'
import LineBreaker from '@/plugins/LineBreaker'
import Hub from '@/plugins/Hub'
import messages from '@/locales'
import Dom3d from '@/plugins/Dom3d'

import * as Sentry from "@sentry/vue"
import { BrowserTracing } from "@sentry/tracing"
import VueMeta from 'vue-meta'

window.isFullLoaded = false

Vue.use(Hub)
Vue.use(Local)
Vue.use(Device)
Vue.use(Offset)
Vue.use(LineBreaker)
Vue.use(VueI18n)
Vue.use(Dom3d)
Vue.use(VueMeta)

import AppImage from '@/components/common/AppImage'

Vue.component('app-image', AppImage)

export const i18n = new VueI18n({
  locale: 'fr',
  messages
})

class vueArtwork {
  constructor () {
    this.vue = new Vue({
      router,
      store,
      i18n,
      render: h => h(App)
    }).$mount('#app')
    this.initSentry()
  }

  initSentry() {
    Sentry.init({
      app: Vue,
      dsn: process.env.VUE_APP_SENTRY_DSN,
      environment: process.env.VUE_APP_SENTRY_ENV,
      integrations: [
        new BrowserTracing({
          routingInstrumentation: Sentry.vueRouterInstrumentation(router),
          tracingOrigins: [process.env.VUE_APP_SENTRY_CRAFT_API, /^\//],
        }),
      ],
      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: 1.0,
    })
  }
}

new vueArtwork()

